import React from "react";
import { tableStyles as s } from "../../ProductLevelChallanData/styles/TableStyles";
import TypographyCompo from "../../../components/Comman/TypographyCompo";
import { lightBrownColor } from "../../../config/ColorObj";

const ProductDataTable = ({ rows }) => {
    if (!rows?.length) {
        return <TypographyCompo style={s.emptyText}>No product data available.</TypographyCompo>;
    }

    return (
        <table style={s.table}>
            <thead>
                <tr>
                    <th style={{ ...s.th, width: 40 }}>#</th>
                    <th style={s.th}>Product Name</th>
                    <th style={{ ...s.th, textAlign: "center" }}>Sell Qty</th>
                </tr>
            </thead>
            <tbody>
                {rows.map((row, i) => (
                    <tr key={i} style={i < rows.length - 1 ? s.row : undefined}>
                        <td style={{ ...s.td, color: lightBrownColor, fontSize: 12 }}>
                            {String(i + 1).padStart(2, "0")}
                        </td>
                        <td style={{ ...s.td, fontWeight: 500 }}>{row.productName}</td>
                        <td style={{ ...s.td, textAlign: "center" }}>
                            <TypographyCompo style={s.badge}>{row.sellQty}</TypographyCompo>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default React.memo(ProductDataTable);